module.exports = __webpack_public_path__ + "img/company.2cf4066f.png";